import { message } from 'antd';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { tokenKey, userInfoKey } from '../utils/localStore';

export const baseUrl = (() => {
  return process.env.PUBLIC_API_URL || '/';
})();

export interface ResponseData<T = unknown> {
  code: number;
  data: T;
  msg: string;
  responseData: string;
}

axios.defaults.baseURL = baseUrl;

// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(tokenKey);
    if (token) {
      config.headers.authorization = token;
    }
    return config;
  },
  (error: AxiosError) => Promise.reject(error),
);

// 添加响应拦截器
axios.interceptors.response.use(
  (response: AxiosResponse<ResponseData>) => {
    const result = response.data;

    if (result instanceof Blob) return Promise.resolve(response);

    if (result.responseData) {
      return Promise.resolve(response);
    }

    if (result.code !== 200) {
      message.error({
        content: result.msg,
        style: {
          marginTop: '70px',
        },
      });
      if (result.code === 600) {
        localStorage.removeItem(tokenKey);
        localStorage.removeItem(userInfoKey);
        localStorage.removeItem('lang');
        window.location.reload();
        return Promise.reject(response);
      }
      return Promise.reject(response);
    }
    return Promise.resolve(response);
  },
  (error: AxiosError) => {
    message.error(error.message);
    return Promise.reject(error);
  },
);

// 统一发起请求的函数
export function request<T>(
  options: AxiosRequestConfig,
): Promise<AxiosResponse<T>> {
  return axios.request<T>(options);
}
